import {
  initFeefoReviewsSchemaMarkup,
  initWriteReviewPopup,
} from '@/utils/Controllers/ReviewsController';

const WRITE_REVIEW_CTA_SELECTOR = '#js-pdp-write-review';

const showMoreReviews = () => {
  const cta = document.getElementById('js-pdp-show-more-reviews');
  if (cta) {
    cta.addEventListener('click', () => {
      const parentEl = cta.parentElement;
      Array.from(parentEl.parentElement.children).forEach(item =>
        item.removeAttribute('hidden'),
      );
      parentEl.removeChild(cta);
    });
  }
};

export const scrollToReview = () => {
  const reviewLink = document.querySelector(
    'a[href^="#"].bra-product-details__reviews-link',
  );

  if (reviewLink) {
    reviewLink.addEventListener('click', e => {
      const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
      e.preventDefault();
      const targetID = reviewLink.getAttribute('href');
      const targetAnchor = document.querySelector(targetID);
      if (!targetAnchor) return;
      const originalTop = distanceToTop(targetAnchor);
      const stickyNavigation = document.querySelector('.bra-sticky-navigation');
      const headerOffset = stickyNavigation ? 225 : 125;

      window.scrollBy({
        top: originalTop - headerOffset,
        left: 0,
        behavior: 'smooth',
      });
      const checkIfDone = setInterval(() => {
        const atBottom =
          window.innerHeight + window.pageYOffset >= document.body.offsetHeight;
        if (distanceToTop(targetAnchor) === 0 || atBottom) {
          targetAnchor.tabIndex = '-1';
          targetAnchor.focus();
          clearInterval(checkIfDone);
        }
      }, 100);
    });
  }
};

export default () => {
  initFeefoReviewsSchemaMarkup();
  showMoreReviews();
  initWriteReviewPopup(WRITE_REVIEW_CTA_SELECTOR);
  scrollToReview();
};
